import { NumberInput, NumberInputProps, useTranslate } from 'react-admin';
import { InputLabel } from '@mui/material';

export const GrayNumberInputWithUpperLabel = (props: NumberInputProps) => {

  const translate = useTranslate();

  return (
    <>
      {props.label !== false && (
        <InputLabel className="input-label">
          {translate(typeof props.label === 'string' ? props.label : '', { _: props.label })}
        </InputLabel>
      )}
      <NumberInput
        {...props}
        label={false}
        inputProps={{
          ...props.inputProps,
          style: {
            backgroundColor: '#f1f1f1',
            borderRadius: '5px',
            ...props.inputProps?.style,
          },
        }}
        sx={{
          mt: 0,
          mb: 0,
          '& fieldset': {
            border: 'none',
          },
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#f1f1f1 !important',
            boxSizing: 'border-box',
            minHeight: props.size === 'small' ? 40 : 56,
            height: props.size === 'small' ? 40 : 56,
            alignItems: 'center',
          },
        }}
      />
    </>
  );

};
